import type { Extend } from '@mentimeter/ragnar-dsc';
import { clsx } from '@mentimeter/ragnar-tailwind-config';
import { CrossIcon } from '@mentimeter/ragnar-visuals';
import * as React from 'react';
import { useTranslations } from 'next-intl';
import type { BoxT } from '../box';
import { Box } from '../box';
import { Clickable } from '../clickable';
import { Text } from '../text';
import { PopoverDismiss } from './PopoverDismiss';

interface PopoverHeaderProps extends BoxT {
  showDismiss?: boolean;
  dismissLabel?: string;
  onDismissClick?: () => void;
  popoverDismissStyles?: Extend;
  children: React.ReactNode;
}

export const PopoverHeader = ({
  showDismiss = true,
  dismissLabel,
  onDismissClick,
  popoverDismissStyles,
  children,
  className,
  ...rest
}: PopoverHeaderProps) => {
  const t = useTranslations('ragnar.popover');
  const closeLabel = dismissLabel
    ? dismissLabel
    : t('close_popover_button_a11y');

  return (
    <Box
      className={clsx(
        ['w-full', 'px-4', '-mb-2', showDismiss ? 'pt-8' : 'pt-3'],
        className,
      )}
      {...rest}
    >
      <Text
        as="h2"
        className="text-text text-100 font-heading font-semibold leading-snug"
        id="ragnar-popover-title"
      >
        {children}
      </Text>
      {showDismiss && (
        <PopoverDismiss>
          <Clickable
            className="absolute top-0 right-0 p-2 z-[1]"
            aria-label={closeLabel}
            onClick={onDismissClick}
            extend={popoverDismissStyles}
          >
            <CrossIcon size={3} />
          </Clickable>
        </PopoverDismiss>
      )}
    </Box>
  );
};
